module.exports = __webpack_public_path__ + "static/media/netresto-1.90549fe4.png";